<template>
  <div class="content-wrapper" :class="{ 'isMobile': isMobile }">
    <div class="history-wrapper" id="history-panel" v-if="!foldHistory">
      <chat-aside />
    </div>
    <div class="right-wrapper">
      <!-- 标题栏使用 flex 布局，图标与标题垂直居中 -->
      <div class="title-wrapper">
        <el-tooltip class="item" effect="dark" placement="top" content="草稿纸">
          <i class="el-icon-edit-outline global-rough-icon" @click="openGlobalRoughPaper"></i>
        </el-tooltip>
        <p class="title">{{ pageTitle }}</p>
      </div>

      <div class="chat-main">
        <el-main class="chat-container" ref="chatContainer">
          <router-view />
        </el-main>
        <el-backtop target=".chat-container" :bottom="100" class="back-top">
          <i class="el-icon-caret-top"></i>
        </el-backtop>
        <BackBottom target=".chat-container" :top="100" class="back-bottom">
          <i class="el-icon-caret-bottom"></i>
        </BackBottom>
      </div>

      <div class="menu" v-if="isMobile">
        <toolbar />
      </div>

      <div class="footer">
        <chat-footer ref="chatFooter" />
      </div>
    </div>

    <!-- 全局草稿纸弹窗 —— 最终版 -->
    <el-dialog
      v-show="globalRoughPaperVisible"
      v-dialogDrag
      width="50%"
      top="21vh"
      class="globalRoughPaperDialog"
      :class="{ 'is-fullscreen': globalRoughPaperFullscreen }"
      :close-on-click-modal="false"
      :visible.sync="globalRoughPaperVisible"
      :append-to-body="true"
      :modal="false"
      ref="globalRoughPaperDialogRef"
      @closed="handleDialogClosed"
    >
      <span slot="title" class="rough-paper-title">
        <i class="el-icon-edit-outline draft-icon"></i>
        <span>草稿纸</span>
      </span>
      <draw-panel
        class="draw-panel"
        :fullscreen.sync="globalRoughPaperFullscreen"
        :storage-key="'global_drawpad'"
      />
      <div slot="footer" class="dialog-footer base-button">
        <button @click="globalRoughPaperVisible = false" style="margin-right: 10px">取 消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import chatAside from "@/components/chat/chatAside.vue";
import chatMain from "@/components/chat/chatMain.vue";
import chatFooter from "@/components/chat/chatFooter.vue";
import BackBottom from "@/components/BackBottom.vue";
import { nanoid } from "nanoid";
import toolbar from "@/components/mobile/toolbar";
import drawPanel from "@/components/draw/index.vue";

export default {
  data() {
    return {
      activeName: "first",
      username: "",
      choosed: "",
      isToBottom: false,
      chatContainer: null,
      globalRoughPaperVisible: false,
      globalRoughPaperFullscreen: false,
    };
  },
  components: {
    chatAside,
    chatMain,
    chatFooter,
    BackBottom,
    toolbar,
    drawPanel,
  },
  computed: {
    ...mapState(["robotId", "sessionId", "robots", "foldHistory", "isMobile"]),
    robotName() {
      let robot = this.robots[this.robotId];
      return robot ? (robot.nickName ? robot.nickName : robot.name) : null;
    },
    pageTitle() {
      if (this.robotName) {
        return `探数蚁｜${this.robotName}`;
      }
      return '探数蚁';
    },
  },
  methods: {
    nanoid() {
      return nanoid();
    },
    /**
     * 打开草稿纸：强制全屏，清除拖拽残留内联样式，
     * 并在显示后再次清除（对抗 v-dialogDrag 的异步写入）
     */
    openGlobalRoughPaper() {
      this.globalRoughPaperFullscreen = true;
      this.clearDialogInlineStyles();
      this.globalRoughPaperVisible = true;
      this.$nextTick(() => {
        this.clearDialogInlineStyles();
      });
    },
    /**
     * 弹窗完全关闭后：退出全屏状态，清除内联样式，
     * 并手动恢复默认 top 值，供下一次非全屏打开使用
     */
    handleDialogClosed() {
      this.globalRoughPaperFullscreen = false;
      this.$nextTick(() => {
        this.clearDialogInlineStyles();
        const dialogRef = this.$refs.globalRoughPaperDialogRef;
        if (dialogRef && dialogRef.$el) {
          dialogRef.$el.style.top = '21vh';
        }
      });
    },
    /**
     * 清除弹窗 DOM 上由 v-dialogDrag 或其它操作产生的内联样式
     */
    clearDialogInlineStyles() {
      const dialogRef = this.$refs.globalRoughPaperDialogRef;
      if (dialogRef && dialogRef.$el) {
        const el = dialogRef.$el;
        el.style.top = '';
        el.style.left = '';
        el.style.margin = '';
        el.style.transform = '';
      }
    },
  },
  mounted() {
    this.chatContainer = this.$refs.chatContainer.$el;
  },
};
</script>

<style lang="scss" scoped>
$bg_color: #e5e9f2;

* {
  color: var(--txt-default-color);
}

::v-deep .el-icon-caret-bottom {
  color: var(--tooltip-bg-color);
}

.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .history-wrapper {
    padding-bottom: 1rem;
    height: 100vh;
    width: 220px;
    box-sizing: border-box;
    border-right: 1px solid var(--border-page);

    header {
      display: flex;
      justify-content: space-between;
    }
  }

  .right-wrapper {
    flex: 5;
    height: 100%;
    background-color: var(--rightbox-bg-color);
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title-wrapper {
      display: flex;
      align-items: center;
      padding: 17px 54px 6px 12px;
      position: sticky;
      top: 0;
      background-color: var(--rightbox-bg-color);
      z-index: 10;
      box-sizing: border-box;
      width: 100%;

      .global-rough-icon {
        font-size: 24px;
        cursor: pointer;
        color: #20b2aa;
        transition: all 0.2s ease;
        margin-right: 8px;
        flex-shrink: 0;
        &:hover {
          color: #2e8b57;
          transform: scale(1.05);
        }
      }

      .title {
        margin: 0;
        line-height: 32px;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        flex: 1;
      }
    }

    .back-bottom {
      position: fixed;
      right: 65px !important;
      bottom: 50% !important;
      transform: translateY(60%) !important;
      border-radius: 50%;
      text-align: center;
      font-size: 20px;
    }

    .back-top {
      text-align: center;
      line-height: 40px;
      right: 65px !important;
      bottom: 50% !important;
      transform: translateY(-60%) !important;
    }

    .back-bottom,
    .back-top {
      opacity: 0.2;
      cursor: pointer;
      &:hover {
        opacity: 1;
        i {
          color: var(--txt-hover-color);
        }
      }
    }

    .footer {
      position: sticky;
      bottom: 25px;
      margin-top: 20px;
      padding-top: 10px;
      padding-right: 54px;
      padding-left: 73px;
      align-items: center;
      color: #333;
      text-align: center;
      z-index: 10;
      background-color: var(--rightbox-bg-color);
    }
  }

  .chat-main {
    display: flex;
    position: relative;
    flex-direction: column;
    flex: 1;
    height: 84vh;
    min-width: 600px;

    .show-tooltip {
      position: absolute;
      top: 1rem;
      left: 5rem;
    }

    .show-area {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
      &:hover {
        background-color: #f1f2f4;
      }
      .show-history {
        width: 20px;
        height: 20px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAb1BMVEVHcEwcICwcICggICAYICgbICkbICsaICkbICobICsaICoaICkbICkbICggICgaICoaICoaICkbICkaICodICkgIDAcICkcICkaICkbICoaICgbICkbICsbICsaICoaICYaICkaICkaICgZICkaICnpACbQAAAAJHRSTlMAQEAQIL8w3+9gn5+QYCCAf6CPr1AQb6/vz39wj3DPUK9QgHCgxU2iAAABcElEQVQ4y7WUW3vCIAyGgXIqa221OnVO3cH//xvXFCjh5C72jJsSeAlpvgRC/jQ2ktLNrxQdhX4sQ+zkM0488FBthZMxt7DFKF79tj6Ls/bGmIM7F15r3fB+sgvvZXDiaIlvlzUTg2/LtffkeK+yAOgSPs9C4gtK0YqKwCZBVVho4STzlsDJYbA1RC5fvLGfjS547Wbz1CCX4e4WHyPkAKn1Yh2jvYQkX5BlN4dTskpCpCfQUKsBpvOXlUnvSKNyqJBHGygibxUS/v57FmwFtQzkByYHl9E+Aa0MytCMdOgKWhLgMY7ToQEkB+XjGby6a5H0Skfdtd/a/7SaHmDaVHsPYM3XaG7rRiPz1mJNuLzDxURr3uFyjqVVlVAUKpC5sotNGDqRx4KVWtt2Iqprl8Ox7DGOyzZh8rjY5ydtWWmVQXJTk8gce4XauH7S9mq8mT8C/nGJx1TOXa8STrCq3Az51U84C1+6SRhzYQ357/EDbiY9xdk68AUAAAAASUVORK5CYII=);
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    .el-main {
      position: relative;
      padding: 0;
      color: #333;
      overflow-x: hidden;
      padding-bottom: 10px;
      .chat-record {
        margin-top: -0.8rem;
      }
    }
  }
}

/* 全局草稿纸弹窗样式 */
.globalRoughPaperDialog {
  ::v-deep .el-dialog {
    background: transparent !important;
    border: 2px solid #9dca67 !important;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(6, 156, 243, 0.3);
  }
  ::v-deep .el-dialog__header,
  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__footer {
    background: transparent !important;
  }
  .rough-paper-title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    .draft-icon {
      font-size: 20px;
      color: #9dca67;
      transition: all 0.25s ease;
      display: inline-block;
    }
    span {
      color: rgb(4, 204, 226) !important;
      font-weight: 600;
      text-shadow: 0 0 2px rgba(247, 230, 154, 0.5);
    }
  }
  ::v-deep .el-dialog__title:hover .draft-icon {
    transform: scale(1.15);
    color: #ffd966 !important;
  }
  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: rgb(250, 100, 62) !important;
    font-size: 24px;
    &:hover {
      color: rgb(247, 3, 15) !important;
    }
  }
  ::v-deep .dialog-footer button {
    background: rgba(0, 0, 0, 0.6) !important;
    border: 1px solid #9dca67 !important;
    color: #d4ff9d !important;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
    &:hover {
      background: rgba(0, 0, 0, 0.8) !important;
      border-color: #ffd966 !important;
      color: #ffd966 !important;
    }
  }
  ::v-deep .draw-panel {
    background: transparent !important;
  }

  // 全屏时强制定位到 (0,0) 并覆盖所有内联样式
  &.is-fullscreen {
    ::v-deep .el-dialog {
      top: 0 !important;
      left: 0 !important;
      margin: 0 !important;
      transform: none !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      width: 100vw !important;
      height: 100vh !important;
      max-height: 100vh !important;
      border-radius: 0 !important;
    }
    ::v-deep .el-dialog__header,
    ::v-deep .el-dialog__footer {
      display: none !important;
    }
    ::v-deep .el-dialog__body {
      padding: 0 !important;
      height: 100vh !important;
    }
    ::v-deep .draw-panel {
      height: 100%;
      border-radius: 0;
    }
  }

  ::v-deep .draw-container .operate-group {
    background-color: rgba(0, 0, 0, 0.7);
  }
}

/* 移动端适配 */
@media (max-width: 1024px) {
  .isMobile {
    .content-wrapper {
      position: relative;
    }
    .chat-main {
      overflow: auto;
      min-width: 90vw;
    }
    .right-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;

      .title-wrapper {
        padding: 12px 12px 6px 12px;
        .global-rough-icon {
          font-size: 20px;
          margin-right: 6px;
        }
        .title {
          line-height: 4vh;
          font-size: clamp(14px, 0.2rem, 18px);
        }
      }

      .footer {
        position: sticky;
        bottom: calc(15px + constant(safe-area-inset-bottom));
        bottom: calc(15px + env(safe-area-inset-bottom));
        padding-left: 0.15rem !important;
        padding-right: 0.15rem !important;
        padding-top: 0;
        width: calc(100vw - 0.3rem);
        margin-top: 0 !important;
        background-color: var(--rightbox-bg-color);
      }

      .menu {
        z-index: 2;
      }

      .el-main {
        padding-right: 0 !important;
        margin-bottom: 10px;
      }

      .back-bottom,
      .back-top {
        right: calc(0.32rem - 10px) !important;
        i {
          color: var(--txt-hover-color) !important;
        }
      }
    }

    #history-panel {
      margin: 0 auto;
      position: absolute;
      right: 0;
      top: 0;
      height: 100vh !important;
      width: 100vw !important;
      z-index: 1000;
      padding-bottom: 0;
    }
  }

  .globalRoughPaperDialog {
    overflow: hidden !important;
    margin-top: 0;
    ::v-deep .el-dialog {
      margin-top: 2vh !important;
      min-width: 92vw;
      min-height: 77vh;
      .el-dialog__body {
        height: 75vh;
        padding: 0 !important;
      }
      canvas {
        height: 70vh;
      }
      &:has(.isFull) {
        width: 100vw !important;
        max-width: 100vw !important;
        height: 100vh !important;
        max-height: 100vh !important;
        margin-top: 0 !important;
        transform: scale(1);
        canvas {
          width: 100%;
          height: 100vh !important;
        }
      }
    }
    .rough-paper-title {
      font-size: 16px;
      span {
        font-size: 16px;
      }
      .draft-icon {
        font-size: 18px;
      }
    }
    ::v-deep .el-dialog__header {
      padding: 10px 16px;
    }
    // 修复移动端关闭按钮与标题栏垂直对齐
    ::v-deep .el-dialog__headerbtn {
      top: 10px;
    }
    ::v-deep .el-dialog__footer {
      padding: 8px 16px;
      button {
        font-size: 14px;
        padding: 6px 16px;
      }
    }
  }
}
</style>